import * as React from "react";
import { IImportedXmlRows } from "../../../models/IImportedXml";
import { Table } from "soprasteria-ui-library";
import { formatPersonalSecurityNumberAndOrganisationNumber } from "../../../helpers/PersonalSecurityNumberAndOrganisationNumberHelper";


interface IImportedXmlDetailsRowTable {
    importedXmlRows: IImportedXmlRows[];
}

export const ImportedXmlDetailsRowTable: React.FunctionComponent<IImportedXmlDetailsRowTable> = ({ importedXmlRows }) => {

    return (
        <Table>
            <thead>
                <tr>
                    <th>Externt ID</th>
                    <th>Mottagning</th>  
                    <th>Personnummer</th>                                    
                    <th>Felmeddelande</th>
                </tr>
            </thead>
            <tbody>
                {
                    importedXmlRows.length > 0 ?
                        <>
                            {
                                importedXmlRows.map((importedXmlRow, key) =>
                                    <tr key={key}>
                                        <td>{importedXmlRow.externalId}</td>
                                        <td>{importedXmlRow.displayCareProviderName}</td>
                                        <td>{formatPersonalSecurityNumberAndOrganisationNumber(importedXmlRow.personalSecurityId)}</td>
                                        <td>
                                            {importedXmlRow.errorMessage ? 
                                            <>
                                                    <div style={{ whiteSpace: "pre-line" }}>{importedXmlRow.errorMessage}</div>
                                            </> : null
                                            }
                                        </td>
                                    </tr>
                                )
                            }
                        </>
                        : <tr><td colSpan={4}>Det finns inga rader att visa</td></tr>
                }
            </tbody>
        </Table>
        );
}